import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import Counter from './Counter';
import { IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

const ImageColorPicker = () => {
  const imageRef = useRef(null);
  const [listenerCount, setListenerCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [isPlaying, setIsPlaying] = useState(false);

  // Login states
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [showLogin, setShowLogin] = useState(true);

  const audioRef = useRef(null);
  const audioRef1 = useRef(null);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
      audioRef1.current.play();
    } else {
      audioRef.current.play();
      audioRef1.current.pause();
    }
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    const updateCount = async () => {
      setIsLoading(true);
      try {
        const hasVisited = sessionStorage.getItem('hasVisited');
        const timeDocRef = doc(db, 'analytics', '2');
        const countDocRef = doc(db, 'analytics', '1');

        const timeDocSnap = await getDoc(timeDocRef);
        if (timeDocSnap.exists()) {
          const { hours, minutes, seconds } = timeDocSnap.data();
          const formattedTime = `${hours}H:${minutes}M:${seconds}S`;
        }

        const countDocSnap = await getDoc(countDocRef);
        if (countDocSnap.exists()) {
          const currentCount = countDocSnap.data().lc || 0;
          if (!hasVisited) {
            const newCount = currentCount + 1;
            await updateDoc(countDocRef, { lc: newCount });
            setListenerCount(newCount);
            sessionStorage.setItem('hasVisited', 'true');
          } else {
            setListenerCount(currentCount);
          }
        } else {
          await setDoc(countDocRef, { lc: 0 });
          setListenerCount(0);
        }
      } catch (error) {
        console.error('Error processing analytics:', error);
      } finally {
        setIsLoading(false);
      }
    };

    updateCount();
  }, []);

  const routeTo = (route, event) => {
    event.preventDefault();
    navigate(route);
  };

  const handleImageClick = (event) => {
    if (showLogin) {
      alert("Please login first to select a region");
      return;
    }

    audioRef1.current.play();

    const { offsetX, offsetY } = event.nativeEvent;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = imageRef.current.width;
    canvas.height = imageRef.current.height;
    ctx.drawImage(imageRef.current, 0, 0);

    const pixelData = ctx.getImageData(offsetX, offsetY, 1, 1).data;

    switch (true) {
      case pixelData[0] >= 252 && pixelData[0] <= 254:
        routeTo('/nepali', event);
        break;
      case pixelData[0] >= 213 && pixelData[0] <= 215:
      case pixelData[0] >= 120 && pixelData[0] <= 122:
      case pixelData[0] >= 234 && pixelData[0] <= 236:
      case pixelData[0] >= 195 && pixelData[0] <= 197:
      case pixelData[0] >= 237 && pixelData[0] <= 239:
      case pixelData[0] >= 173 && pixelData[0] <= 175:
        routeTo('/bengali', event);
        break;
      case pixelData[0] >= 192 && pixelData[0] <= 194:
        routeTo('/nepali', event);
        break;
      default:
        console.log('No region matched');
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (!mobile || !password) {
      alert("Please enter both mobile number and password");
      return;
    }
    console.log("Login attempt with:", mobile);
    setShowLogin(false);
  };

  const login = async (mobile, password) => {

    const docRef = doc(db, "user", String(mobile));
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      if(docSnap.data().password === password) {
        localStorage.setItem('mobile', mobile);
        localStorage.setItem('login', 'true');
        localStorage.setItem('admin', docSnap.data().admin || 'false');
        setShowLogin(false);
        navigate('/dashboard');
      }
      else {
        alert("Incorrect password!");
        setShowLogin(true);
      }
    } else {
      alert("User not found!");
      setShowLogin(true);
    }
    // console.log("Logging in with:", mobile, password);
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f0cdb7' }}>
      {/* Sticky Navbar */}
      <div style={{ position: 'fixed', top: 0, width: '100%', zIndex: 1000, background: 'rgba(255, 255, 255, 0.9)', boxShadow: '0 2px 5px rgba(0, 128, 0, 0.1)', padding: '10px 0', height: '24%' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '0 10px', maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ marginLeft: '-40px', padding: '5px', width: '80px' }}>
           
           
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <img ref={imageRef} src="/heading.png" style={{ width: '100%', height: '10vh', cursor: 'pointer', marginTop: '0px' }} alt="Sample Image" onClick={handleImageClick} />
          </div>


        </div>

        <div style={{ width: '90%', maxWidth: '800px', margin: '0 auto 1.5rem', display: 'flex', justifyContent: 'center' }}>
          <div style={{ background: 'rgba(255, 255, 255, 0.2)', backdropFilter: 'blur(8px)', padding: '0.5rem 8rem', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0, 128, 0, 0.15)', height: '50px' }}>
            <Counter text="Total Users" listenerCount={listenerCount} />
          </div>
        </div>
      </div>

      {/* Main Image Section */}
      <div style={{ paddingTop: '200px' }}>
        {isLoading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#2e7d32', fontSize: '1.2rem' }}>Loading...</div>
        ) : (
          <div style={{ position: 'relative', width: '100vw', height: '35vh' }}>
            <img ref={imageRef} src="/student.jpg" alt="Student Background" style={{ position: 'absolute', top: 300, left: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', cursor: showLogin ? 'default' : 'pointer', zIndex: 1 }} onClick={handleImageClick} />

            {/* Login Overlay */}
            {showLogin && (
              <div>
                <div style={{ position: 'absolute', top: 20, left: 0, width: '100%', height: '90%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5 }}>
                  <div style={{ backgroundColor: '#ffffff', padding: '1.5rem 2rem', borderRadius: '12px', boxShadow: '0 10px 40px rgba(0,0,0,0.4)', width: '90%', maxWidth: '380px', textAlign: 'center' }}>
                    <h3 style={{ color: '#2e7d32', marginBottom: '1.8rem' }}>Login to Continue</h3>

                    <form onSubmit={handleLogin}>
                      <input type="tel" placeholder="Mobile Number" value={mobile} onChange={(e) => setMobile(e.target.value)} style={{ width: '100%', padding: '14px', marginBottom: '15px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '1rem' }} required />
                      <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ width: '100%', padding: '14px', marginBottom: '25px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '1rem' }} required />
                      <button type="submit" style={{ width: '100%', padding: '14px', backgroundColor: '#2e7d32', color: 'white', border: 'none', borderRadius: '8px', fontSize: '1.05rem', fontWeight: '500', cursor: 'pointer' }} onClick={() => login(mobile, password)}>Login</button>
                    </form>

                    <p style={{ marginTop: '1px', color: '#666', fontSize: '0.75rem' }}>Don't have an account? <span onClick={() => navigate('/register')} style={{ color: '#3b82f6', cursor: 'pointer', fontWeight: '600' }}>Apply Online</span></p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Bottom Footer */}


      <div style={{ position: 'fixed', bottom: 0, height: '90px', width: '100%', zIndex: 1000, background: 'rgba(255, 255, 255, 0.9)', boxShadow: '0 2px 5px rgba(0, 128, 0, 0.1)' }}>
        <center>
          <p style={{ color: 'darkgreen', marginTop: '15px' }}>कालिम्पोङ प्रहरी विभागको पहल</p>
        </center>


            <div style={{ marginTop: '-10px', marginLeft: '60px', display: 'flex', alignItems: 'center' }}>
              { <audio ref={audioRef1} autoPlay src="https://firebasestorage.googleapis.com/v0/b/gorkha-police.firebasestorage.app/o/Vandemataram.mp3?alt=media&token=88828947-478e-4c9b-920f-0fbddf7294ab" /> }
              <div>
                <audio ref={audioRef} src="https://firebasestorage.googleapis.com/v0/b/gorkha-police.firebasestorage.app/o/Prayash.mp3?alt=media&token=7a277701-7f0d-47b5-a2f2-86bd830d8c06" />
                <IconButton onClick={togglePlayPause} color="primary">
                  {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
                </IconButton>
              </div>
              <p style={{ marginLeft: '-10px', marginTop: '0px', color: '#388e3c', fontSize: '0.9rem' }}>About The Platform</p>
            </div>




      </div>
      





    </div>
  );
};

export default ImageColorPicker;